import { makeStyles } from '@material-ui/styles';

import { Text, MainButton } from '@bizzabo/design-system';

import useOtherUser from '../../hooks/useOtherUser';
import useCancelMeeting from '../../hooks/useCancelMeeting';
import { ScheduledMeeting } from '../../types';
import ScheduleModal from '../../components/ScheduleModal';
import useTypeTracking from '../../../../analytics';
import { useMeetings } from '../../MeetingsTool/MeetingsToolContext';
import LoaderSpinner from '../../../../people/components/LoaderSpinner';

interface CancelMeetingModalProps {
    isOpen: boolean;
    meeting: ScheduledMeeting;
    closeModal: () => void;
}

const CancelMeetingModal: React.FC<CancelMeetingModalProps> = ({ isOpen, meeting, closeModal }) => {
    const { data: otherUser, isSuccess } = useOtherUser(meeting);
    const { trackClickEvent } = useTypeTracking();
    const { eventId } = useMeetings();
    const cancelMeeting = useCancelMeeting();

    const classes = useStyles();

    const onCancel = () => {
        cancelMeeting.mutate(
            {
                eventId,
                meetingId: meeting.id,
            },
            {
                onSuccess: () => {
                    closeModal();
                },
            }
        );
        trackClickEvent({
            subCategory: 'MEETING_CANCELLED',
        });
    };

    return (
        <ScheduleModal isOpen={isOpen} closeModal={closeModal}>
            {isSuccess && (
                <>
                    <Text variant="t50" className={classes.titleModal}>
                        {`Are you sure you want to cancel your meeting with ${otherUser.firstName}?`}
                    </Text>
                    <MainButton
                        onClick={onCancel}
                        variant="fill"
                        before={cancelMeeting.isLoading && <LoaderSpinner />}
                    >
                        {cancelMeeting.isLoading ? 'Canceling' : 'Yes, Cancel'}
                    </MainButton>
                </>
            )}
        </ScheduleModal>
    );
};

const useStyles = makeStyles(
    () => ({
        titleModal: {
            marginBottom: 24,
            textAlign: 'center',
        },
    }),
    { classNamePrefix: 'meetings-cancel-modal' }
);

export default CancelMeetingModal;
